import { RouterModule, Routes } from '@angular/router';
import { AddToolComponent } from './tools/components/add-tool/add-tool';
import { NgModule } from '@angular/core';
import { ViewToolsComponent } from './tools/components/view-tools/view-tools';
import {HomePageComponent} from './homepage/homepage';
import { LoginComponent } from './login/login';
import { ChangePasswordComponent } from './change-password/change-password';
import { SelectToolComponent } from './deeplink/components/select-tool/select-tool';
import { DebugComponent } from './debug/debug';
import { LaunchToolComponent } from './launch-tool/launch-tool';
import { DeeplinkLaunchComponent } from './deeplink/components/deeplink-launch/deeplink-launch';
import { ViewShellCoursesComponent } from './shell-courses/components/view-shell-courses/view-shell-courses';
import { DeeplinkConclusionComponent } from './deeplink/components/deeplink-conclusion/deeplink-conclusion';
import { ShowLinkedSubCoursesComponent } from './deeplink/components/show-linked-sub-courses/show-linked-sub-courses';
import { AddShellCoursesComponent } from './shell-courses/components/add-shell-courses/add-shell-course';
import { ViewLineItems } from './grade-book/components/view-line-items/view-line-items';
import { ViewGradeBookComponent } from './grade-book/components/view-grade-book/view-grade-book';
import { ViewLessonsComponent } from './lessons/components/view-lessons/view-lessons';
import { AddLessonsComponent } from './lessons/components/add-lessons/add-lessons';
import { MessageComponent } from './message/message';
import { ShowLinkedSubCoursesTestComponent } from './deeplink/components/show-linked-sub-courses-test/show-linked-sub-courses-test';

export const routes: Routes = [
    { path: '', component: LoginComponent },
    { path: 'login', component: LoginComponent },
    { path: 'home', component: HomePageComponent },
    { path: 'add-tool', component: AddToolComponent },
    { path: 'view-tools', component: ViewToolsComponent },//TODO: EDIT and INACTIVE
    { path: 'view-shell-courses', component: ViewShellCoursesComponent },
    { path: 'change-password' , component: ChangePasswordComponent},
    { path: 'select-tool/:courseCode' , component: SelectToolComponent},
    { path: 'debug' , component: DebugComponent},//TODO: to implement cleanly
    { path: 'open-course/:courseCode/:sessionId', component: LaunchToolComponent},
    { path: 'deeplink-launch/:toolId/:courseCode', component: DeeplinkLaunchComponent },
    { path: 'deeplink-conclusion' , component: DeeplinkConclusionComponent },
    { path: 'show-linked-sub-courses/:courseCode/:sessionId' , component: ShowLinkedSubCoursesComponent },
    { path: 'show-linked-sub-courses-test/:courseCode' , component: ShowLinkedSubCoursesTestComponent },
    { path: 'add-shell-courses' , component: AddShellCoursesComponent},
    { path: 'view-line-items' , component: ViewLineItems},
    { path: 'view-grade-book/:lineItemId/:courseCode', component: ViewGradeBookComponent },
    { path: 'view-lessons', component: ViewLessonsComponent },
    { path: 'add-lessons', component: AddLessonsComponent },
    { path: 'message/:messageType/:messageCode', component: MessageComponent }
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class AppRoutingModule { }
